import { Vue } from 'vue-property-decorator'
import _ from 'lodash'
import { BaseClient } from '@/api/base'

export default class extends Vue {
  protected id: number = -1
  protected client: BaseClient
  protected data: any
  protected rules: any
  protected listLoading = false

  public constructor() {
    super()
    this.client = new BaseClient('')
  }

  async created() {

  }

  public async getData(id = -1) {
    this.id = id
    const form = this.$refs['dataForm'] as any
    this.$nextTick(() => {
      form.clearValidate()
    })
    if (Number(this.id) !== -1) {
      this.listLoading = true
      this.data = this.formatData(await this.client.get(this.id))
      this.listLoading = false
    }
  }

  protected formatData(data:any):any {
    return data
  }

  public async reset() {
    this.data = {}
  }

  protected generateData():any {
    return this.clearData(_.pick(this.data, ['createdAt', 'updatedAt']))
  }

  protected clearData(data:any) {
    const args = Object.keys(data)
    for (const arg of args) {
      if (_.isNull(data[arg])) {
        data[arg] = undefined
      }
    }
    return data
  }

  public async saveData():Promise<Boolean> {
    const self = this
    const form = self.$refs['dataForm'] as any
    return new Promise<Boolean>((resolve, reject) => {
      form.validate(async(valid: any) => {
        if (valid) {
          if (await this.beforeSave()) {
            if (Number(this.id) !== -1) {
              self.listLoading = true
              await self.client.update(
                self.id,
                self.generateData()
              )
              self.listLoading = false
              resolve(true)
            } else {
              await self.client.create(self.generateData())
              resolve(true)
            }
            self.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          }
        } else {
          resolve(false)
        }
      })
    })
  }

  protected async beforeSave():Promise<Boolean> {
    return true
  }
}
